<template>
  <BreadCrumb PageTitle="Mes Files et Dossiers" />
  <AgentFiles />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AgentFiles from "../../components/Agent/AgentFiles.vue";

export default defineComponent({
  name: "AgentFilesPage",
  components: {
    BreadCrumb,
    AgentFiles,
  },
});
</script>